export const colors = {
  bg0: '#060816',
  bg1: '#0B1020',
  bg2: '#10182B',
  surface1: '#111827',
  surface2: '#172033',
  surface3: '#1C2740',
  primary: '#1E90FF',
  primary2: '#3AA0FF',
  secondary: '#8B5CF6',
  secondary2: '#A855F7',
  accent: '#00D4FF',
  success: '#22C55E',
  warning: '#F59E0B',
  error: '#EF4444'
};

export const radius = {
  sm: 10,
  md: 14,
  lg: 18,
  xl: 24
};

export const shadows = {
  sm: '0 8px 24px rgba(0, 0, 0, 0.22)',
  md: '0 14px 40px rgba(0, 0, 0, 0.28)',
  glowPrimary: '0 0 0 1px rgba(30, 144, 255, 0.10), 0 12px 44px rgba(30, 144, 255, 0.08)'
};

export const motion = {
  fast: 160,
  normal: 220,
  slow: 320
};

